import { GenericListByConfig } from './GenericList';

/**
 * The operations Contacts list.
 *
 * Contacts are external people (client reps, assessor/collector reps, …), a
 * separate concern from internal users — the crud router already excludes
 * internal-user rows — so the list shows contact identity + company without the
 * internal `type` column (and its filter).
 */
export function ContactsListPage() {
  return (
    <GenericListByConfig
      table="contacts"
      title="People"
      columns={['first_name', 'last_name', 'company_name']}
    />
  );
}
